<mat-form-field class="dict-pages">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="pageFilterCtrl" placeholderLabel="Nazwa ..."
                             noEntriesFoundLabel="Nie znaleziono OFWCA">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items" [value]="option.uuid">
      <ng-container >
        {{option.name}}
      </ng-container>
    </mat-option>

  </mat-select>
  <button *ngIf="((control.value !== null
  && multiple && control.value.hasOwnProperty('length')
  && control.value.length > 0) || (!multiple && control.value))
  && !required && !control.disabled"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
